export const TESTING_CENTERS_REQUEST = "testeingCentersConstants/TESTING_CENTERS_REQUEST";
export const TESTING_CENTERS_SUCCESS = "testeingCentersConstants/TESTING_CENTERS_SUCCESS";
export const TESTING_CENTERS_FAIL = "testeingCentersConstants/TESTING_CENTERS_FAIL";
